export default __webpack_public_path__ + "static/media/Wolf's Gloves of World's Edge.d2e46421.jpg";